import React from 'react'

import { useMutation } from '@apollo/client'

import ActionButton, {
  ActionButtonIcon,
  ActionButtonType,
} from '$extensionSrc/components/ActionButton'
import InteractiveElement from '$extensionSrc/components/InteractiveElement'
import Toast from '$extensionSrc/components/Toast'
import { appleMailURL, gmailURL } from '$extensionSrc/consts/urlConsts'
import { unauthClient } from '$serverSrc/apolloClientUnauth'
import { resendEmailMutation } from '$serverSrc/data/queryUnauth'

import './ConfirmEmailPrompt.scss'

export default function ConfirmEmailPrompt({ email }: { email: string }) {
  const [requestResendEmail, { data: responseData }] = useMutation(
    resendEmailMutation,
    { client: unauthClient },
  )

  const resendEmailStatusCode =
    responseData?.requestEmailConfirmationEmail?.statusCode
  const resendEmailError = responseData?.requestEmailConfirmationEmail?.error

  const sendRequestResendEmail = () => {
    requestResendEmail({
      variables: {
        email,
      },
    })
  }

  return (
    <>
      <div className="ConfirmEmailPrompt">
        <div className="header">
          <div className="header-content heading1 bold">
            Confirm your email address
          </div>
          <div className="header-content body1">
            Follow the link we sent to {email}.
          </div>
        </div>
        <div className="body">
          <ActionButton
            className="email-button apple"
            iconName={ActionButtonIcon.APPLE_MAIL}
            iconBorder
            onClick={() => window.open(appleMailURL, '_blank')}
            type={ActionButtonType.SECONDARY}
          >
            Open Mail
          </ActionButton>
          <ActionButton
            className="email-button"
            iconName={ActionButtonIcon.GMAIL}
            iconBorder
            onClick={() => window.open(gmailURL, '_blank')}
            type={ActionButtonType.SECONDARY}
          >
            Open Gmail
          </ActionButton>
        </div>
        <div className="footer body2">
          Didn't get a link? Check your spam folder first.
          <br />
          If you still don't see it,{' '}
          <InteractiveElement
            className="link2"
            onClick={sendRequestResendEmail}
          >
            get a new link
          </InteractiveElement>
          .
        </div>
      </div>
      {resendEmailStatusCode !== 200 && resendEmailError && (
        <Toast
          text="We could not resend your confirmation email, please try signing up again"
          color="red"
          dismissAfterMs={6000}
        />
      )}
      {resendEmailStatusCode === 200 && !resendEmailError && (
        <Toast text={`Successfully resent email to ${email}`} color="yellow" />
      )}
    </>
  )
}
